module.exports = __webpack_public_path__ + "img/adulto41.76ff6332.jpg";